export const styles = {
  hidden: {
    display: 'none',
  },
}
